// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QEcC","top":"styles_top__1DlrQ","left":"styles_left__39--d","description":"styles_description__2jIP5"};